var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvasElement",style:(_vm.canvasStyle),attrs:{"width":_vm.canvasSize.x,"height":_vm.canvasSize.y}})}
var staticRenderFns = []

export { render, staticRenderFns }